export default "__VITE_ASSET__VA6GxVqn__"